import { useState, useEffect } from "react";

export function useImagesLoaded(imageUrls = []) {
  const [imagesLoaded, setImagesLoaded] = useState(false);

  useEffect(() => {
    if (!imageUrls.length) {
      setImagesLoaded(true);
      return;
    }
    let loaded = 0;
    const onLoad = () => {
      loaded++;
      if (loaded >= imageUrls.length) setImagesLoaded(true);
    };
    const onError = () => {
      loaded++;
      if (loaded >= imageUrls.length) setImagesLoaded(true);
    };
    const imgs = imageUrls.map((url) => {
      const img = new window.Image();
      img.onload = onLoad;
      img.onerror = onError;
      img.src = url;
      return img;
    });

    return () => {
      imgs.forEach(img => {
        img.onload = null;
        img.onerror = null;
      });
    };
  }, [imageUrls]);

  return imagesLoaded;
}

